export function decimalFormat(val: any, decimalPlaces: any = 2): string {
  if (!val) {
    return '0,00';
  }
  let returnVal = val;
  if (typeof returnVal === 'string') {
    returnVal = Number(returnVal.replace(',', '.'));
  }
  return returnVal.toLocaleString('pt-BR', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
}
